export default __webpack_public_path__ + "static/media/logoCouleurs.157b5828.png";